import { IAudit } from '../../../../../app/entities/Audit'
import { STATUS } from '../../types/audit'

export function getAuditByObjectId(auditObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/byObjectId/${auditObjectId}`,
    method: 'GET',
  }
}
export function getExampleImages(auditType: STATUS, sectionKey: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/example-images?auditType=${auditType}&sectionKey=${sectionKey}`,
    method: 'GET',
  }
}
export function getInstallationImages(orderVehicleObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/images/installation/${orderVehicleObjectId}`,
    method: 'GET',
  }
}
export function getOrderVehicle(orderVehicleObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/order_vehicles/${orderVehicleObjectId}`,
    method: 'GET',
  }
}
export function getDvirImages(virObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/images/vir/${virObjectId}`,
    method: 'GET',
  }
}
export function putAudit(audit: IAudit) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/`,
    method: 'PUT',
    body: audit,
  }
}
export function getAuditSections(auditObjectId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/${auditObjectId}/sections`,
    method: 'GET',
  }
}
